export function CourseForumAliasAside({ alias }: { alias: string }) {
  return (
    <div className="lms-course-forum-alias-pill">
      <span className="material-symbols-outlined lms-course-forum-alias-pill__icon" aria-hidden="true">
        fingerprint
      </span>
      <span className="lms-course-forum-alias-pill__label">Tu alias:</span>
      <span className="lms-course-forum-alias-pill__value">{alias}</span>
      <span className="lms-course-forum-alias-pill__anon">
        <span className="lms-course-forum-alias-pill__dot" aria-hidden="true" />
        <span className="lms-course-forum-alias-pill__anon-text">Anónimo</span>
      </span>
    </div>
  );
}
